<template>
  <div class="hora">
    <div
      v-if="!isLoading && loadData"
      class="show container"
      style="font-family: IRANSansX-Regular">

      <div
        class="row justify-content-md-center"
        style="direction: ltr"
      >
        <div class="col-12  mr-auto mx-auto mb-3 p-0">
          <div
            id="accordionPanelsStayOpenPlanetryPlanetry"
            class="accordion mr-auto mx-auto"
          >
            <div class="accordion-item">
              <h3
                id="panelsStayOpenPlanetry-headingOne"
                class="accordion-header">
                <button
                  class="accordion-button accordion-custom-butt on"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpenPlanetry-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpenPlanetry-collapseOne"
                >
                  جدول سیاره‌ای
                </button>
              </h3>
              <div
                id="panelsStayOpenPlanetry-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpenPlanetry-headingOne"
              >
                <div
                  class="accordion-body p-1"
                  style="background-color: #f9f9f9; overflow-y: scroll"
                >
                  <!-- <pre>
                  {{ loadData }}
                </pre> -->
                  <PTableFree
                    :grahas="loadData['graha']"
                    :lagna="loadData['lagna']"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoadingReport
      v-else
      :is-loading="isLoading" />
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'
import PTableFree from './PTableFree.vue'
// import ChartInfoFree from "../components/ChartInfoFree.vue";
// import ChartAnalysisFree from "../components/ChartAnalysisFree.vue";
import ShareLinkFree from '../components/ShareLinkFree.vue'
import PlanetryTableReport from '../components/PlanetryTableReport.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
// import NoteListPro from "../components/NoteListPro.vue";
import ApiService from '../service/api'
import LoadingReport from '../components/LoadingReport.vue'

export default {
  name: 'FreePTable',
  components: {
    Chart,
    // ChartInfoFree,
    // ChartAnalysisFree,
    PTableFree,
    DashaTable,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    // NoteListPro,
    ApiService,
    LoadingReport
  },
  data () {
    return {
      isLoading: false,
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    loadData: function (data) {
      this.loadData = data
    }
  },
  mounted: function () {
    // this.adjustBoxesWidth();
  },
  created () {
    let id = document.getElementsByName('share_id')[0]['value']

    const request = {
      'id': id,
      'part': 0
    }
    this.isLoading = true
    ApiService.getFreeChartPart(request).then((response) => {
      this.isLoading = false
      this.loadData = response['data']
    })
  },
  methods: {
    // adjustBoxesWidth() {
    //   if (screen.width > 960) {
    //     // DESKTOP
    //     this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100;
    //     this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100;
    //   } else {
    //     this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100;
    //     this.main_box_width = this.box_width;
    //   }
    // },
    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px; 
      border-radius: 8px; 
      width: ${width}px;  
      line-height: 10px; 
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.loadData = data
      // this.$chartNoteListRef.getList();
    },
    updateShowAnalysisOption (data) {
      this.show_analysis = data
    }
  }
}
</script>

<style scoped>
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
